import React from "react";
import { Popover, ConfigProvider } from "antd";

import { Colors } from "../../config";

const WhitePopover = ({
  content,
  placement = "leftTop",
  title = null,
  trigger = "click",
  children,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: "white",
          colorText: "black",
          controlItemBgHover: Colors.LightSecondary,
        },
      }}
    >
      <Popover
        placement={placement}
        title={title ?? null}
        content={content}
        arrow={{ pointAtCenter: true }}
        trigger={trigger ?? "click"}
      >
        {children}
      </Popover>
    </ConfigProvider>
  );
};

export default WhitePopover;
